import { gql } from "@apollo/client";

export const removePin = gql`
    mutation removePin($groupId: String, $organizationId: String = null) {
        selectedOrganization @client {
            id @export(as: "organizationId")
        }
        removePin(input: { groupId: $groupId, organizationId: $organizationId }) {
            groupId
        }
    }
`;
